/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetSynevoOrderDto } from './GetSynevoOrderDto';
import {
    GetSynevoOrderDtoFromJSON,
    GetSynevoOrderDtoFromJSONTyped,
    GetSynevoOrderDtoToJSON,
} from './GetSynevoOrderDto';
import type { GetUserDto } from './GetUserDto';
import {
    GetUserDtoFromJSON,
    GetUserDtoFromJSONTyped,
    GetUserDtoToJSON,
} from './GetUserDto';
import type { GetExamDto } from './GetExamDto';
import {
    GetExamDtoFromJSON,
    GetExamDtoFromJSONTyped,
    GetExamDtoToJSON,
} from './GetExamDto';

/**
 * 
 * @export
 * @interface GetSynevoDto
 */
export interface GetSynevoDto {
    /**
     * 
     * @type {string}
     * @memberof GetSynevoDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof GetSynevoDto
     */
    systemNumber: number;
    /**
     * 
     * @type {GetUserDto}
     * @memberof GetSynevoDto
     */
    doctor?: GetUserDto | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetSynevoDto
     */
    sentOrder: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSynevoDto
     */
    cancelOrder: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetSynevoDto
     */
    sentOrderId: string;
    /**
     * 
     * @type {Date}
     * @memberof GetSynevoDto
     */
    creationTs?: Date;
    /**
     * 
     * @type {GetExamDto}
     * @memberof GetSynevoDto
     */
    exam: GetExamDto;
    /**
     * 
     * @type {Array<GetSynevoOrderDto>}
     * @memberof GetSynevoDto
     */
    synevoOrders?: Array<GetSynevoOrderDto> | null;
}

/**
 * Check if a given object implements the GetSynevoDto interface.
 */
export function instanceOfGetSynevoDto(value: object): value is GetSynevoDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('systemNumber' in value) || value['systemNumber'] === undefined) return false;
    if (!('sentOrder' in value) || value['sentOrder'] === undefined) return false;
    if (!('cancelOrder' in value) || value['cancelOrder'] === undefined) return false;
    if (!('sentOrderId' in value) || value['sentOrderId'] === undefined) return false;
    if (!('exam' in value) || value['exam'] === undefined) return false;
    return true;
}

export function GetSynevoDtoFromJSON(json: any): GetSynevoDto {
    return GetSynevoDtoFromJSONTyped(json, false);
}

export function GetSynevoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSynevoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'systemNumber': json['systemNumber'],
        'doctor': json['doctor'] == null ? undefined : GetUserDtoFromJSON(json['doctor']),
        'sentOrder': json['sentOrder'],
        'cancelOrder': json['cancelOrder'],
        'sentOrderId': json['sentOrderId'],
        'creationTs': json['creationTs'] == null ? undefined : (new Date(json['creationTs'])),
        'exam': GetExamDtoFromJSON(json['exam']),
        'synevoOrders': json['synevoOrders'] == null ? undefined : ((json['synevoOrders'] as Array<any>).map(GetSynevoOrderDtoFromJSON)),
    };
}

export function GetSynevoDtoToJSON(value?: GetSynevoDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'systemNumber': value['systemNumber'],
        'doctor': GetUserDtoToJSON(value['doctor']),
        'sentOrder': value['sentOrder'],
        'cancelOrder': value['cancelOrder'],
        'sentOrderId': value['sentOrderId'],
        'creationTs': value['creationTs'] == null ? undefined : ((value['creationTs']).toISOString()),
        'exam': GetExamDtoToJSON(value['exam']),
        'synevoOrders': value['synevoOrders'] == null ? undefined : ((value['synevoOrders'] as Array<any>).map(GetSynevoOrderDtoToJSON)),
    };
}

